
import { setTieuChuanApi } from '../../../api/set-tieu-chuan/setTieuChuanApi';
import { ISetTieuChuanRequest } from '../../../model/request/set-tieu-chuan/ISetTieuChuanEditRequest';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ISetTieuChuan } from '../../../model/respone/set-tieu-chuan/ISetTieuChuan';
import { eSetTieuChuanActionTypeIds, ISetTieuChuanActions } from '../../action-types/set-tieu-chuan/ISetTieuChuanActions';
import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.setTieuChuan.setTieuChuan;
// const subAction = rootActions.setTieuChuan.sanPham;

export function* setTieuChuanSaga(): any {
    yield takeLatest(eSetTieuChuanActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eSetTieuChuanActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSetTieuChuanActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ISetTieuChuanActions): any {
    const payload = action.payload as number
    const res: IBaseRespone = yield call(setTieuChuanApi.SelectByCoSo, payload)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ISetTieuChuanActions): any {

    const payload = action.payload as ISetTieuChuanRequest;
    const res = yield call(setTieuChuanApi.SaveChange, payload)
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
        yield put(rootActions.setTieuChuan.sanPham.LOAD_START(undefined))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ISetTieuChuanActions): any {
    const res: IBaseRespone = yield call(setTieuChuanApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}